import {
    handleChange,
    setFormGroupVisibility,
    updateFormGroupLabel,
    debounce,
    smoothScrollToElement
} from './functions';
import {
    getPayDatesForPayFrequency,
    setPayDate
} from './pay-dates';
import { setupAmountTermLockout, formatCurrency } from '../amount-term-lockout';
import { showLoadingBar } from './loading-spinner';
import { setupQuoteboost } from './quoteboost';

const SUBMISSION_TIMEOUT_MS = 1000 * 60 * 5;

// Includes
require('./address');
require('./date-input');
require('./sortcode');

// Form validation
$.formValidation(
    '.apply-form', {
    // displayMessages: function(inputs, messages, settings) {
    // },
    url: '/apply',
    validateUrl: '/validate',
    throwErrors: false,
    form: {
        status: {
            valid: function (xhr, statusText, settings) {
                handleFormSubmitSuccess(xhr.responseJSON);
            },
            invalid: function (xhr, statusText, settings) {
                // Scroll to the first validation fail
                if (xhr.responseJSON && xhr.responseJSON.errors && xhr.responseJSON.errors != null) {
                    // Display errors
                    let errors = xhr.responseJSON.errors;
                    let selectors = [];
                    Object.keys(errors).forEach(key => {
                        // Show any form groups with errors
                        let selector = '.form-group[data-form-group-name=' + key + ']';
                        let formGroup = $(selector);
                        selectors.push(selector);
                        if (formGroup.length === 1 && formGroup.is('.hidden')) {
                            setFormGroupVisibility(key, true);
                        }
                    });
                    // Scroll to first error
                    let firstError = $(selectors.join(', ')).first();
                    if (firstError.length === 1) {
                        smoothScrollToElement(firstError);
                    }
                }
            }
        }
    },
        status: {
            valid: function (xhr, statusText, settings) {
            },
            invalid: function (xhr, statusText, settings) {
                let inputs = settings.$inputs;
                let result = xhr.responseJSON;
            }
        }
    }
);

export function fireConversions(id, c) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'application_complete',
        application_commission: (c || 0),
        customer: id
    });
}

export function defaultRedirect(id) {
    dataLayer = dataLayer || [];
    dataLayer.push({
        'event': 'app',
        'appStatus': 'declined'
    });
    top.location = window.DEFAULT_EXIT;
}

export function doCustomSignpostCheck(url) {
    if(/moneywellness/.test(url)) {
        moneywellnessSpinnerTransform();
    }
    if(/phonexa/.test(url)) {
        customLenderSpinnerTransform('Loans 2 Go');
    }
}

export function customLenderSpinnerTransform(lender) {
    document.getElementById('default-spinner-text').classList.add('hidden');
    document.getElementById('default-spinner-footer-text').classList.add('hidden');
    document.getElementById('progress-bar-circle').classList.add('complete', 'tick');
    document.getElementById('custom-lender-name').innerHTML = lender;
    document.getElementById('lender-spinner-text').classList.remove('hidden');
}

export function moneywellnessSpinnerTransform() {
    document.getElementById('default-spinner-text').classList.add('hidden');
    document.getElementById('default-spinner-footer-text').classList.add('hidden');
    document.getElementById('progress-bar-circle').classList.add('complete', 'tick');
    document.getElementById('mwg-spinner-text').classList.remove('hidden');
}

export function finalRedirect(url, id, c) {
    fireConversions(id, c);
    try {
        window.axios.get("/conv/" + id + "/" + parseFloat(c));
    } catch(e) {}
    setTimeout(function () {
        location.href = url;
    }, 6000);
}

export function handleFormSubmitSuccess(data) {
    if (data.id) {
        // Start the check loop
        window.APPLICATION_SUBMITTED_AT = new Date();
        window.DEFAULT_EXIT = (data.default || '');
        showLoadingBar();
        checkApplicationStatus(data.id);
    }
}

export function checkApplicationStatus(id) {
    var now = (new Date()).getTime();
    if (window.APPLICATION_SUBMITTED_AT != null && now - window.APPLICATION_SUBMITTED_AT > SUBMISSION_TIMEOUT_MS) {
        // Timeout reached, send to the
        defaultRedirect(id);
    } else {
        // Go and get the check
        let promise = $.ajax({
            url: '/check',
            method: 'POST',
            data: {
                id: id
            }
        });

        promise.then(
            function (data) {
                if (data.status === 'processing') {
                    setTimeout(function () {
                        checkApplicationStatus(id);
                    }, 5000);
                }
                if (data.status === 'complete' && data.accepted && typeof data.url !== 'undefined') {
                    // Get the url and redirect
                    doCustomSignpostCheck(data.url);
                    finalRedirect(data.url, id, (data.commission || 0));
                }
                if (data.status === 'complete' && !data.accepted) {
                    // Get the url and redirect
                    defaultRedirect(id);
                }
                if (data.status === 'error' && data.description === 'no results') {
                    defaultRedirect(id);
                }
                if (data.status === 'error' && data.description === 'not in panel') {
                    defaultRedirect(id);
                }
            }
        );

        promise.fail(
            function () {
                setTimeout(function () {
                    checkApplicationStatus(id);
                }, 5000);
            }
        );

    }
}

$(".show-form").click(function () {
    $('.form-section-home-page').removeClass('hidden');
    smoothScrollToElement($('.form-section-home-page'));
});

// Dependants handler
// handleChange('[name=do_you_have_any_dependants]', (event, value, target) => {
//     setFormGroupVisibility('no_of_dependents', value == '1');
// });

// Any other loans
handleChange('[name=any_other_loans]', (event, value, target) => {
    setFormGroupVisibility('monthly_loan_repayments', value == 1);
});

// Employment status field changes
handleChange('[name=employment_status]', (event, value, target) => {
    var input = $(event.target);
    var value = input.val();
    var form = input.closest('form');
    var industryField;
    // Tweak any form labels that need to be changed
    if (window.fieldData && window.fieldData.pay_frequency && window.fieldData.pay_frequency.employmentStatusLabelMap) {
        updateFormGroupLabel('pay_frequency', window.fieldData.pay_frequency.employmentStatusLabelMap[value || 'emp_fulltime']);
    }
    // Deal with showing or hiding
    if (['emp_fulltime', 'emp_parttime', 'emp_self'].includes(value)) {
        // Show the right fields
        setFormGroupVisibility(
            ['job_title', 'employer', 'months_in_work', 'industry', 'pay_frequency', 'monthly_pay', 'pensions_income_monthly', 'benefits_income_monthly', 'other_income_monthly'],
            true
        );
        let jobTitle = $('[name=job_title]');
        if (jobTitle.length === 1) {
            jobTitle[0].value = '';
        }
        let employerName = $('[name=employer]');
        if (employerName.length === 1) {
            employerName[0].value = '';
            form.find(employerName).val('');
        }
        if (value === 'emp_self') {
            setFormGroupVisibility(
                'employer',
                false
            );
            form.find(employerName).val('emp_self');
        }
        let industry = $('[name=industry]');
        if (industry.length === 1) {
            industry[0].value = '';
            industryField = form.find('.form-field[data-update-field=industry]');
            industryField.find('.pseudo-selected').removeClass('pseudo-selected');
        }
    } else {
        // Hide the fields we don't need
        setFormGroupVisibility(
            ['job_title', 'employer', 'months_in_work', 'industry', 'pay_frequency', 'monthly_pay', 'pensions_income_monthly', 'benefits_income_monthly', 'other_income_monthly'],
            false
        );
        // months_in_work
        // Show the fields we do
        setFormGroupVisibility(
            ['months_in_work', 'pay_frequency', 'monthly_pay', 'pensions_income_monthly', 'benefits_income_monthly', 'other_income_monthly'],
            true
        );
        if (['student', 'homemaker', 'unemployed', 'retired', 'disability_benefits', 'benefits'].includes(value)) {
            setFormGroupVisibility(
                ['monthly_pay'],
                false
            );
        }
        let jobTitle = $('[name=job_title]');
        if (jobTitle.length === 1) {
            jobTitle.value = value;
            form.find(jobTitle).val(value);
        }
        let employerName = $('[name=employer]');
        if (employerName.length === 1) {
            employerName[0].value = value;
            form.find(employerName).val(value);
        }
        let industry = $('[name=industry]');
        if (industry.length === 1) {
            industry[0].value = 'other_not_office_based';
        }
    }
});

// Months in work change handler
if (window.fieldData && window.fieldData.months_in_work && window.fieldData.months_in_work.monthsInWorkLabelMap) {
    handleChange('[name=employment_status]', (event, value, target) => {
        updateFormGroupLabel('months_in_work', window.fieldData.months_in_work.monthsInWorkLabelMap[value || 'emp_fulltime']);
    });
}

// Residential status change handler
if (window.fieldData && window.fieldData.housing && window.fieldData.housing.residentialStatusLabelMap) {
    handleChange('[name=residential_status]', (event, value, target) => {
        updateFormGroupLabel('housing', window.fieldData.housing.residentialStatusLabelMap[value || 'homeowner']);
    });
}

// Monthly pay change
// commented out this function so we don't run and see the calculation, this is not needed for this current form question context
// $(document).on('keyup', '[name=monthly_pay]', debounce(event => {
//     let val = event.target.value;
//     if (/^\d+$/.test(val)) {
//         let annual = Math.floor((val * 1.2 * 12) / 1000) * 1000;
//         let formGroup = $('.form-group[data-form-group-name=monthly_pay]');
//         let microText = formGroup.find('.estimated-annual');
//         if (microText.length === 1) {
//             formatCurrency
//             microText.html('£' + formatCurrency(annual));
//             microText.closest('.estimated-annual-pay').removeClass('hidden');
//         }
//     } else { }
// }, 250, false));

// Pay frequency change handler
handleChange('[name=pay_frequency]', (event, value, target) => {
    // Calculate the pay dates
    let payDates = getPayDatesForPayFrequency(value);
    if (payDates === null) {
        // Show the dates
        setFormGroupVisibility(['next_pay_date', 'following_pay_date'], true);
    } else {
        // Attempt to set the pay dates
        setPayDate('next_pay_date', payDates[0]);
        setPayDate('following_pay_date', payDates[1]);
        setFormGroupVisibility(['next_pay_date', 'following_pay_date'], false);
    }
});

// This assumes only one loan amount and term on a form page
setupAmountTermLockout($('[name=loan_amount]'), $('[name=loan_term]'));
setupQuoteboost();

$(document).on('click', '.main-header-row-summary-button', event => {
    $('.main-header-row-summary').addClass('hidden');
    $('.main-header-row-fields').removeClass('hidden');
});

$(document).on('focus', '.select-on-focus', function (event) {
    $(this).select();
});

// Marital status change handler
handleChange('[name=marital_status]', (event, value, target) => {
    setFormGroupVisibility('combined_pay', ['married', 'living_together', 'other'].includes(value));
});

$(".marketing-checkbox").click(function () {
    $(".marketing-checkbox").toggleClass("marketing-checkbox-active");
    if ($(".marketing-checkbox").hasClass("marketing-checkbox-active")) {
        $('[name=marketing]').val(1);
    } else {
        $('[name=marketing]').val(0);
    }
});

function populateConsents(form) {
    let consentsField = form.find('[name=consents]');
    if (consentsField.length === 0) {
        consentsField = $('<input type="hidden" name="consents">').prependTo(form);
    }
    let commPrefSection = $('#communication_preferences_section');
    let consents = {};
    if (commPrefSection.length === 1) {
        let commPrefText = commPrefSection.text();
        let commPrefArray = (commPrefSection.find('[name=communication_preferences]').val().toString() || '').split(',');
        consents.communication_preference_email = {
            url: location.href,
            consent_given: commPrefArray.includes('email'),
            text: commPrefText
        };
        consents.communication_preference_sms = {
            url: location.href,
            consent_given: commPrefArray.includes('sms'),
            text: commPrefText
        };
        consents.communication_preference_whatsapp = {
            url: location.href,
            consent_given: commPrefArray.includes('whatsapp'),
            text: commPrefText
        };
    }
    consentsField.val(JSON.stringify(consents));
}

function calculateAge(dateOfBirth, dateToCalculate) {
    var calculateYear = dateToCalculate.getFullYear();
    var calculateMonth = dateToCalculate.getMonth();
    var calculateDay = dateToCalculate.getDate();

    var birthYear = dateOfBirth.getFullYear();
    var birthMonth = dateOfBirth.getMonth();
    var birthDay = dateOfBirth.getDate();

    var age = calculateYear - birthYear;
    var ageMonth = calculateMonth - birthMonth;
    var ageDay = calculateDay - birthDay;

    if (ageMonth < 0 || (ageMonth == 0 && ageDay < 0)) {
        age = parseInt(age) - 1;
    }
    return age;
}

//convert the date string in the format of dd/mm/yyyy into a JS date object
function parseDate(dateStr) {
    var dateParts = dateStr.split("-");
    return new Date(dateParts[0], (dateParts[1] - 1), dateParts[2]);
}

handleChange('[name=communication_preferences]', (event, value, target) => {
    populateConsents(target.closest('form'));
});

//if customer selects debt consolidation as a purpose, then show vulnerable customer help text 
$(document).on('change', '[name=purpose]', function (event) {
    if ($('[name="purpose"]').val() == 'debt_consolidation') {
        $('#purpose-help-text-1').slideDown(250);
     } else {
        $('#purpose-help-text-1').slideUp(250);
     }
 });

//if customer selects unemployed show vulnerable customer help text 
$(document).on('change', '[name=employment_status]', function (event) {
    if ($('[name="employment_status"]').val() == 'unemployed') {
        $('#employment_status-help-text-3').slideDown(250);
     } else {
        $('#employment_status-help-text-3').slideUp(250);
     }
 });

//if customer selects benefits show vulnerable customer help text 
$(document).on('change', '[name=employment_status]', function (event) {
    if ($('[name="employment_status"]').val() == 'benefits') {
        $('#employment_status-help-text-2').slideDown(250);
     } else {
        $('#employment_status-help-text-2').slideUp(250);
     }
 });

 //if customer selects student show vulnerable customer help text 
$(document).on('change', '[name=employment_status]', function (event) {
    if ($('[name="employment_status"]').val() == 'student') {
        $('#employment_status-help-text-4').slideDown(250);
     } else {
        $('#employment_status-help-text-4').slideUp(250);
     }
 });

 //if customer selects benefits show vulnerable customer help text 
$(document).on('change', '[name=employment_status]', function (event) {
    if ($('[name="employment_status"]').val() == 'disability_benefits') {
        $('#employment_status-help-text-5').slideDown(250);
     } else {
        $('#employment_status-help-text-5').slideUp(250);
     }
 });

//if customer is between 18 and 20 y.o we show a dropdown to FAQs
$(document).on('change', '[name=dob]', function (event) {
    var age = calculateAge(parseDate($('[name=dob]').val()), new Date());
    if (age >= '18' && age <= '20') {
        $('#dob-help-text-1').slideDown(250);
    } else {
        $('#dob-help-text-1').slideUp(250);
    }
});

//if customer is applying for 10k loan, is 21 or younger AND earns less than 12k a year (977 a month) then show vulnerable customer help text 
$(document).on('change', '[name=dob]', function (event) {
    var age = calculateAge(parseDate($('[name=dob]').val()), new Date());
    if ($('[name=loan_amount]').val() == '10000' && age <= '21' && $('[name=monthly_pay]').val() <= 977) {
        $('#monthly_pay-help-text-1').slideDown(250);
    } else {
        $('#monthly_pay-help-text-1').slideUp(250);
    }
});

//this logic checks if there is a clad cookie for amount term and purpose and uses that to set the amount & value. If there is a query string value for loan amount then that will override the cookie value.

document.addEventListener("DOMContentLoaded", function() {
    function getCookie(name) {
        let cookieArr = document.cookie.split(";");
        for(let i = 0; i < cookieArr.length; i++) {
            let cookiePair = cookieArr[i].split("=");
            if(name == cookiePair[0].trim()) {
                return decodeURIComponent(cookiePair[1]);
            }
        }
        return null;
    }

    function getQueryStringValue(name) {
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(window.location.href);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    const loanAmountQS = getQueryStringValue("loan_amount");

    let useCookieValues = true;
    if (loanAmountQS) {
        useCookieValues = false;
    }

    let loanAmountCookie, loanTermCookie, cladPurposeCookie;
    if (useCookieValues) {
        loanAmountCookie = getCookie("clad_la");
        loanTermCookie = getCookie("clad_term");
        cladPurposeCookie = getCookie("clad_purpose");
    }

    const loanAmountElement = document.getElementById("loan_amount");
    const loanTermElement = document.getElementById("loan_term");
    if (loanAmountElement && loanTermElement) {
        if (!useCookieValues && loanAmountQS) {
            loanAmountElement.value = loanAmountQS;
            document.querySelectorAll(".loan_amount_formatted").forEach(element => {
                element.textContent = loanAmountQS;
            });
        } else if (useCookieValues && loanAmountCookie) {
            loanAmountElement.value = loanAmountCookie;
            document.querySelectorAll(".loan_amount_formatted").forEach(element => {
                element.textContent = loanAmountCookie;
            });
        }
        if (useCookieValues && loanTermCookie) {
            loanTermElement.value = loanTermCookie;
            document.querySelectorAll(".loan_term").forEach(element => {
                element.textContent = loanTermCookie;
            });
        }
    }

    if (cladPurposeCookie) {
        const purposeGroup = document.querySelector('[data-form-group-name="purpose"]');
    
        if (purposeGroup) {
            const buttons = purposeGroup.querySelectorAll('[data-value]');
            const purposeInput = document.querySelector('input[name="purpose"]');
    
            buttons.forEach(function (button) {
                if (button.getAttribute('data-value') === cladPurposeCookie) {
                    button.classList.add('active');
                    if (purposeInput) {
                        purposeInput.value = button.getAttribute('data-value');
                    }
                } else {
                    button.classList.remove('active');
                }
            });
        }
    }
});

